<!--  -->
<template>
	<div>
    <div class="logo">
        <img src="../assets/AILAND.png" alt="">
    </div>
    <div class="circle">
        <div class="circle1">
          <img src="../assets/circle_01.png" alt="">
        </div>
        <div class="circle2">
          <img src="../assets/circle_02.png" alt="">
        </div>
        <div class="circle3">
          <img src="../assets/circle_03.png" alt="">
        </div>
        <div class="circle4">
          <img src="../assets/circle_04.png" alt="">
        </div>
    </div>
    <div class="dl"> 
        <div class="picture" id="container"></div>
        <div class="login_content">
            <div class="biaoti">
                <img src="../assets/biaoti_03.png" alt="">
            </div>
            <div class="dl_01">
                <div id="dl_code" class="code">
                   <img src="../assets/code.png" @click="showsaoma" title="扫码登录更便捷" alt="">
                </div>

            </div>
             <div v-show="dl_code2" class="dl_02">
                   <div id="dl_code02" class="code_02">
                       <img src="../assets/mima_01.png" @click="hidesaoma" title="密码登录" alt="">
                   </div>
                   <div class="scan_code">
                       <img src="../assets/success.png" alt="">
                   </div>
                   <div class="tips">
                    <p style="text-align: center;font-size:20px;font-weight:bold;">扫描成功，登录中...</p>
                   </div>
                   <div class="atips">
                       <!-- <a href="https://work.weixin.qq.com/#indexDownload" target="_blank" style="color:#f198a7 ;">点击下载企业微信安装包</a> -->
                   </div>  
            </div>
            <div  v-if="wj" class="dl_03" >
                <div id="dl_code1" class="code_02">
                    <img src="../assets/code.png" title="扫码登录更便捷" alt="">
                </div>
                <div class="wj_text">
                    <input type="text" name="" placeholder="请输入手机/账号">
                </div>
                <div class="wj_text2">
                    <input type="text" name="" placeholder="请输入密码">
                </div>
                <div class="wj_text3">
                    <input type="text" name="" placeholder="验证码">
                    <button type="button" class="hq_code" >获取验证码</button>
                </div>
                <button type="button" class="login_button">登 录</button>
                
            </div>
            <div class=" three_sides">
                <ul>
                    <li><a href="">财务软件</a></li>
                    <li><a href="">财务软件</a></li>
                    <li><a href="">财务软件</a></li>
                </ul>
            </div>   
        </div>
    </div>
    <div class="versnumber">
        <span>Copyright©2007-2022  &nbsp; 爱恋珠宝信息中心  &nbsp;  www.ailend.com   &nbsp;   ©蜀ICP备06023048号</span>
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				show:true,
				show2:true,
				code: '',
				state: '',
				appid: '',
				wj: false,
				dl_code2: true,
				// user_date: '11111',
			};
		},

		components: {},
		created:function(){

		},
		mounted: function() {
			const container = document.getElementById("container");
			console.log(container.style.backgroundPositionX)
			console.log(container.style.backgroundPositionY)
			window.onmousemove = function(e){
				let x = e.clientX / 10;
				container.style.backgroundPositionX = (-440 + x) + "px";
			}
			let _this = this;


			setTimeout(()=>{					//加密狗注释代码
				console.log("加密狗");			//加密狗注释代码
				this.delay();					//加密狗注释代码
			},1000);							//加密狗注释代码

			// this.loadingform();				//加密狗注释代码-------测试开放/正式注释


		},
		computed: {},

		methods: {
			doginfo:function(){
				// console.log("执行加密狗方法")
				Button1_onclick();
			},
			delay:function(){
				let _this = this;
				if(localStorage.hfkeyid){
					// console.log("获取加密狗成功")
					_this.loadingform();
				}else{
					// console.log("获取加密狗失败，重新获取")
					setTimeout(function(){
						_this.doginfo();
						_this.delay();
					},1000);
				}
			},
			loadingform:function(){
				let _this = this;
				var regExp = new RegExp('([?]|&)userno=([^&]*)(&|$)'); //取post页面传过来的值。
				var result = window.location.href.match(regExp);
				if(localStorage.hfkeyid && localStorage.hfkeyid !=""){					//加密狗注释代码
        
					if (result != null && result.length > 1) {
						console.log(result);
						var userno = result[2];
						let postData = this.$qs.stringify({
							version:API.VERSION_NUM,
							userno: userno,
							Encrypted:localStorage.hfkeyid,
							type:0,											//0不要加密狗 1要加密狗   ----加密狗修改项----
						});
						// console.log("last-userno:", postData);
						this.$axios({
							method: "POST",
							url: API.API_TOKEN + "PublicLogin/SweepCode",
							data: postData
						}).then(res => {
							console.log("中转页面数据---", res);
							console.log("中转页面数据error_code---", res.data.error_code);
							if (res.data.error_code == "65302") {
								// this.user_date = res.data
								this.$router.push({
									path: '/',
									query: {
										middle_result: res.data.error_code
									}
								})
							} else if (res.data.error_code == "0") {
								console.log("中转页面数据000000---", res.data.error_code);
								// this.user_date = res.data
								setTimeout(()=>{
									this.show2 = false;
								},500);
								setTimeout(()=>{
									this.show = false;
								},800);
								localStorage.tnk = res.data.iphone;
								localStorage.fzhitype = res.data.data[0].areaname;		//获取是否是直营店
								localStorage.equitygroupid = res.data.data[0].equitygroupid;	//控制下柜下拉值---内容
								localStorage.frmv = res.data.data[0].mwPwd;	//帆软
								localStorage.pe = res.data.data[0].phone;	//电话号码
								setTimeout(()=>{
									this.$router.push({
										path: '/index_new',
		// 								query: {
		// 									middle_result: this.user_date.error_code,··
		// 									iphone_code: this.user_date.iphone
		// 								}
									})
								},1100);
							}else{
								if (res.data.error_code == '1002') {
									_this.$message({
										message: '密码和用户名不能为空',
										type: 'warning'
									});
								}
								if (res.data.error_code == '65302') {
									_this.$message({
										message: '该用户不存在',
										type: 'warning'
									});
								}
								if(res.data.error_code == '65303'){
									_this.$message({
										message: '密码错误或者帐号与加密狗不匹配！',
										type: 'warning'
									});
								}
								setTimeout(()=>{
									window.location.href = API.LOCATIONS_URL;
									window.location.reload;
									// _this.$router.push('/');
								},1000);
							}
						}).catch(res => {
							// console.log("用户验证失败", res);
							// window.location.href = '/newPage'
							console.log("二次加密狗");
							Button1_onclick();							//加密狗注释代码
						});
					} else { //传过来的参数为空
						userno = result;
						_this.$router.push({
							path: '/',
							query: {
								middle_result: '65302'
							}
						})
					}

				}else{													//加密狗注释代码
					return false;
					setTimeout(()=>{									//加密狗注释代码
						console.log("1116556");							//加密狗注释代码
						window.location.href = API.LOCATIONS_URL;		//加密狗注释代码
						window.location.reload; 						//加密狗注释代码
						_this.$router.push('/');						//加密狗注释代码
					},1000);											//加密狗注释代码
				}														//加密狗注释代码
			},
		}
	}
</script>
<style scoped>
	* {
  box-sizing: border-box;
}
html,
body {
  background: #fef5f7;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.logo {
  position: absolute;
  width: 100%;
  height: 100px;
  padding-left: 80px;
  padding-top: 40px;
  left: 0;
  top: 0;
  z-index: 1;
}
.circle {
  position: absolute;
  left: 0;
  top: 0;
  padding-left: 50px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  z-index: 2;
}
.circle1 {
  position: absolute;
  transform-origin: center;
  animation: Qz 30s infinite linear;
}
.circle2 {
  position: absolute;
  transform-origin: center;
  animation: Qz 18s infinite linear;
}
.circle3 {
  position: absolute;
  transform-origin: center;
  animation: Qz 24s infinite linear;
}
.circle4 {
  position: absolute;
  transform-origin: center;
  animation: Qz 13s infinite linear;
}
.dl {
  position: absolute;
  width: 1200px;
  height: 800px;
  background: white;
  border-radius: 20px;
  z-index: 5;
  margin-top: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  top: 60px;
  right: 80px;
}
.picture {
  position: relative;
  width: 710px;
  height: 800px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  float: left;
  margin-left: 500px;
  z-index: 9999;
  background-image: url(../assets/picture.png);
  background-position-x: -440px;
  background-position-y: -70px;
}
.login_content {
  position: absolute;
  /* width: 400px;
    height: 530px;
    background:red;
    left: 50px;
    top: 100px;  */
}
.biaoti {
  /* text-align: left; */
  /* background: red; */
  margin-top: 100px;
  padding-left: 50px;
}
.dl_01 {
  position: absolute;
  width: 400px;
  height: 400px;
  background: white;
  left: 50px;
  top: 190px;
}
.code {
  text-align: right;
  /* background: red;
    padding-top: 40px;
    margin-left: 40px;     */
}
.box{
  margin-top: 55px;
}
/deep/ .el-input__inner {
  position: relative;
  border-radius: 5px;
  /* width: 394px; */
  /* height: 40px; */
  /* border-radius: 8px; */
  /* margin: 20px 0; */
  /* background: url(../assets/zhanghao.png) no-repeat; */
  /* background-position: 15px 5px; */
  /* background-color: white; */
  /* background-position: 14px; */
  padding-left: 50px;
  /* border: 1px solid #e4e4e4; */
  /* outline: none; */
  /* margin-top: 60px; */
}
/deep/ .el-input-group__prepend{
  position: absolute;
  left: 0;
  top: 0;
  background: none;
  border: none;
  z-index: 1;
  padding-top: 7px;
}
.box2 input {
  width: 394px;
  height: 40px;
  border-radius: 8px;
  margin: 10px 0;
  background: url(../assets/mima.png) no-repeat;
  background-color: white;
  background-position: 14px;
  padding-left: 50px;
  border: 1px solid #e4e4e4;
  outline: none;
}
.forget {
  font-size: 12px;
  color: #f198a7;
  text-align: right;
  margin-top: -70px;
}
.login_button {
  width: 394px;
  height: 46px;
  border-radius: 8px;
  background-color: #f198a7;
  margin-top: 60px;
  color: #fff;
  border: none;
  font-size: 16px;
  outline: none;
}
.login_button:hover{
  box-shadow: 0 0 5px #f198a7 !important;
  background-color: #f198a7 !important;
  color: #fff !important;
}
.three_sides {
  font-size: 8px;
  /* text-align:center; */
  padding-top: 620px;
  padding-left: 70px;
}
.three_sides ul li {
  list-style: none;
  float: left;
  padding-left: 30px;
}
.three_sides ul li a {
  color: rgb(196, 196, 196);
  text-decoration: none;
}
.three_sides ul li a:hover {
  color: #f198a7;
}
.login_content2 {
  position: absolute;
  width: 400px;
  height: 530px;
  background: white;
  left: 600px;
  top: 140px;
  z-index: 9999;
}
.scan_code {
  text-align: center;
  /* margin-top: 60px; */
}
.tips {
  font-size: 12px;
}
.atips {
  font-size: 12px;
  text-align: center;
  margin-top: 30px;
}
.dl_02 {
  position: absolute;
  width: 400px;
  height: 400px;
  background: white;
  left: 50px;
  top: 190px;
  z-index: 5;
}
.code_02 {
  text-align: right;
}
.dl_03 {
  position: absolute;
  width: 400px;
  height: 400px;
  background: white;
  left: 50px;
  top: 190px;
  z-index: 6;
}
.code_03 {
  text-align: right;
}
.wj_mk {
  position: absolute;
  width: 400px;
  height: 530px;
  background: white;
  left: 600px;
  top: 140px;
  z-index: 9999;
}
.wj_code {
  text-align: right;
  padding-top: 40px;
}
.wj_text input {
  width: 394px;
  height: 40px;
  border-radius: 8px;
  margin: 20px 0;
  background: url(../assets/zhanghao.png) no-repeat;
  background-color: white;
  background-position: 14px;
  padding-left: 50px;
  border: 1px solid #e4e4e4;
  outline: none;
  margin-top: 60px;
}
.wj_text2 input {
  width: 394px;
  height: 40px;
  border-radius: 8px;
  margin: 10px 0;
  background: url(../assets/mima.png) no-repeat;
  background-color: white;
  background-position: 14px;
  padding-left: 50px;
  border: 1px solid #e4e4e4;
  outline: none;
}
.wj_text3 input {
  width: 308px;
  height: 40px;
  border-radius: 8px;
  margin: 10px 0;
  background: url(../assets/test.png) no-repeat;
  background-color: white;
  background-position: 14px;
  padding-left: 50px;
  border: 1px solid #e4e4e4;
  outline: none;
}
.wj_button {
  width: 394px;
  height: 46px;
  border-radius: 8px;
  background-color: #f198a7;
  margin-top: 40px;
}
.wj-but {
  background-color: #f198a7;
  color: white;
  outline: none;
  font-size: 16px;
  padding-top: 10px;
}
.hq_code {
  border: 1px solid #f198a7;
  border-radius: 8px;
  height: 40px;
  background-color: white;
  color: #f198a7;
  outline: none;
}
.versnumber {
  width: 100%;
  height: 40px;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  margin: 0 auto;
  /* background: #f198a7; */
  padding-top: 10px;
  z-index: 10;
}
.versnumber span {
  margin-left: 640px;
  color: #666666;
}

@keyframes Qz {
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/deal_data.vue